module.exports = __webpack_public_path__ + "img/audio-tips.175244a4.jpg";